<template>
  <div id="app">
    <router-view v-if="routerState"></router-view>
  </div>
</template>
<style />
<script>
import { Env } from './scripts/AllExport'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data: function () {
    return {
      routerState: true,
      routerShow: false
    }
  },
  beforeMount() {
  },
  mounted() {
    this.init()
  },
  methods: {
    reload() {
      this.routerState = false;
      this.$nextTick(() => {
        this.routerState = true;
      })
    },
    landing() {

    },
    timeout(ms) {
      return new Promise((resolve) => { setTimeout(resolve, ms) })
    },
    init() {
    }
  }
}
</script>

  <style scoped>
#appLoadingAll {
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  background-color: #000;
  height: 100vh;
  width: 100%;
}
@-webkit-keyframes appImgkeyframes {
  from {
    z-index: 11;
    opacity: 1;
  }
  to {
    z-index: 9;
  }
}

@keyframes appImgkeyframes {
  from {
    z-index: 11;
    opacity: 1;
  }
  to {
    z-index: 9;
  }
}
.appImg {
  z-index: 10;
  opacity: 1;
  height: 100vh;
  width: 100%;
  position: absolute;
  background-color: hsla(0, 0%, 100%, 0);
  object-fit: cover;
}

#appImg2 {
  -webkit-animation: appImgkeyframes 3.6s 0s ease-in-out;
  animation: appImgkeyframes 3.6s 0s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/App.vue